import { infiniteQueryOptions, keepPreviousData } from '@tanstack/react-query';

import API from '@api';
import { ELEMENTS_QUASTIONS } from '@constants/ElementsLimit';
import { withSsrCache } from '../../ssrCache';

export const FAQS_ALL_QUERY_KEY = 'faqsAll';

/**
 * Вопросы шефу (/faq): пагинация + поиск + фильтр «мои вопросы».
 * Поиск и фильтр входят в ключ; страница — pageParam. initialPage —
 * стартовая страница из URL (/faq/page/N), при поиске всегда 1.
 *
 * КЭШ ВКЛЮЧАЕМ ТОЛЬКО ПРИ mePeopleIdFilter === false. Ключ здесь
 * ПОЗИЦИОННЫЙ — значения лежат в массиве без имён, — поэтому проверка
 * персональных маркеров внутри `withSsrCache` его не разбирает и защитить
 * не может: строка `true` в четвёртой позиции для неё неотличима от любого
 * другого параметра. Ветку выбираем руками, снаружи.
 */
export const faqsAllInfiniteQueryOptions = (params: {
  search: string;
  mePeopleIdFilter: boolean;
  initialPage?: number;
}) => {
  const options = infiniteQueryOptions({
    queryKey: [
      FAQS_ALL_QUERY_KEY,
      'infinite',
      params.search,
      params.mePeopleIdFilter
    ],
    queryFn: ({ pageParam }) =>
      API.getFaqsAll({
        page: pageParam,
        setLimit: ELEMENTS_QUASTIONS,
        search: params.search,
        mePeopleIdFilter: params.mePeopleIdFilter
      }).then(res => ({
        items: res?.getFaqsAll?.faqItems ?? [],
        total: res?.getFaqsAll?.totalCount || 0
      })),
    initialPageParam: params.initialPage || 1,
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (!lastPage.items.length) {
        return undefined;
      }

      const loadedCount = allPages.reduce(
        (acc, pageData) => acc + pageData.items.length,
        0
      );

      return loadedCount < lastPage.total ? lastPageParam + 1 : undefined;
    },
    placeholderData: keepPreviousData
  });

  return params.mePeopleIdFilter ? options : withSsrCache(options);
};
